import { ReactElement } from 'react'
import { Box } from '@mui/material'
import { FileListTitleInput } from './FileListTitleInput'

export interface EditableFileListTitleProps {
  name: string
  isEditing: boolean
  onEditingChange: (isEditing: boolean) => void
  /** Called with the trimmed name, only when it is non-empty and differs from `name`. */
  onRename: (name: string) => void
  /** Whether a click on the title starts editing (otherwise the click reaches the row). */
  canRenameByClick: boolean
}

/**
 * Click-to-rename `FileListRow` title. Editing can also be started from outside (e.g. an edit
 * icon in the row actions) via `isEditing`/`onEditingChange`.
 */
export const EditableFileListTitle = ({
  name,
  isEditing,
  onEditingChange,
  onRename,
  canRenameByClick,
}: EditableFileListTitleProps): ReactElement => {
  if (isEditing) {
    return (
      <FileListTitleInput
        initialName={name}
        onCommit={draftName => {
          onEditingChange(false)
          const trimmed = draftName.trim()
          if (trimmed && trimmed !== name) onRename(trimmed)
        }}
        onCancel={() => onEditingChange(false)}
      />
    )
  }

  return (
    <Box
      onClick={event => {
        if (!canRenameByClick) return
        event.stopPropagation()
        onEditingChange(true)
      }}
      title={canRenameByClick ? 'Zum Umbenennen klicken' : undefined}
      sx={{
        fontSize: 13,
        height: '19px',
        lineHeight: '19px',
        color: 'text.primary',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        cursor: canRenameByClick ? 'text' : 'inherit',
      }}
    >
      {name}
    </Box>
  )
}
